import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import req from "../req";
import config from "../config";
import Button from "../sections/MUI/Button";
import Modal from "../sections/MUI/Modal";
import Field from "../sections/MUI/Field";
import Select from "../sections/MUI/Select";
import {toast} from "react-toastify";

const list = config.smsPatterns;

class SMS extends Component {

    state = {
        smsList: [],

        pattern: list[0],
        phones: [],

        phone: "",
        name: "کاربر قسطی تک",

        search: "",

        modalPhone: false
    };

    componentDidMount() {
        this.getPhones();
        this.getSMSList();
    }


    getPhones() {
        let {search} = this.state;
        req.get(`/sms/phones?token=${config.token}&s=${search}`)
            .then(r => {
                let list = r ? r : [];
                list = list ? list : [];
                this.setState({phones: list});
            })
    }

    getSMSList() {
        req.get(`/sms/send/list?token=${config.token}`)
            .then(r => {
                let list = r ? r : [];
                list = list ? list : [];
                this.setState({smsList: list});
            })
    }

    handlePatternChange(p = "") {
        let index = -1;
        list.map((it, i) => {
            if (it.p === p) {
                index = i;
            }
        });
        if (index !== -1) {
            this.setState({pattern: list[index]});
        }
    }

    sendSMS() {
        let {name, phone} = this.state;
        name = name ? name.toString().trim() : "";
        phone = phone ? phone.toString().trim() : "";
        let pattern = this.state.pattern.p;
        let patternText = this.state.pattern.t;

        if (name !== "" && phone !== "" && pattern !== "") {
            toast.info("در حال ارسال ...");
            req.post(`/sms/send?token=${config.token}`, {
                phone, pattern, name, patternText
            })
                .then(r => {
                    toast.success("پیامک با موفقیت ارسال شد!");
                });
        } else {
            toast.error("همه فیلدها را تکمیل کنید!");
        }
    }

    render() {
        let {smsList, phones, pattern, name, phone, search, modalPhone} = this.state;
        return (
            <div className="sms">
                <Modal display={modalPhone}
                       onCloseClick={() => this.setState({modalPhone: false})}
                       title="انتخاب کاربر">
                    <div className="modal-select-user">
                        <div className="row">
                            <div className="col-8">
                                <Field name="search"
                                       value={search}
                                       maxLength={350}
                                       label="نام یا شماره"
                                       onChange={(name, value) => this.setState({[name]: value})}/>
                            </div>
                            <div className="col-4">
                                <Button icon="search" onClick={() => this.getPhones()}>جستجو</Button>
                            </div>
                        </div>
                        {
                            phones?.map((u, i) =>
                                <article key={"user" + i} onClick={() => {
                                    this.setState({
                                        name: u.fullName,
                                        phone: u.phone,
                                        modalPhone: false
                                    });
                                }}>
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <div
                                                className="full-name">{u.fullName.toString().trim() === "" ? "بدون نام" : u.fullName.toString().trim()}</div>
                                        </div>
                                        <div className="col-auto">
                                            <div className="phone">{u.phone}</div>
                                        </div>
                                    </div>
                                </article>
                            )
                        }
                    </div>
                </Modal>
                <Back {...this.props}/>
                <br/>

                <div className="row">
                    <div className="col-xl-4 col-lg-5 col-md-6">
                        <Button icon="plus" onClick={() => this.setState({modalPhone: true})}>انتخاب کاربر</Button>
                    </div>
                </div>
                <br/>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <Field name="name"
                               value={name}
                               label="نام و نام خانوادگی"
                               maxLength={350}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">
                        <Field name="phone"
                               type="number"
                               value={phone}
                               label="شماره موبایل"
                               maxLength={11}
                               style={{direction: "ltr"}}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-12">
                        <Select name="pattern"
                                value={pattern.p}
                                label="پترن"
                                options={list.map(it => {
                                    return {
                                        t: name.toString().trim() === "" ? it.t : it.t.replace("%name%", name),
                                        v: it.p
                                    }
                                })}
                                onChange={(name, value) => this.handlePatternChange(value)}/>
                    </div>

                    {
                        name.toString().trim() !== "" && phone.toString().trim() !== "" ?
                            <div className="col-12">
                                <br/><br/>
                                <div className="row justify-content-center">
                                    <div className="col-md-5">
                                        <Button icon="check" onClick={() => this.sendSMS()}>ارسال پیامک</Button>
                                    </div>
                                </div>
                            </div>
                            : null
                    }

                </div>
                <br/>
                <div className="list-send-sms">
                    {smsList?.reverse()?.map((it, i) =>
                        <article key={"ss-" + i}>
                            <div className="row">
                                <p className="phone">{it.phone}</p>
                                <p className="name">{it.name}</p>
                            </div>
                            <p className="text">{it.text}</p>
                        </article>
                    )}
                </div>
            </div>
        );
    }
}

export default gpn(SMS);